export default {
  url: process.env.REACT_APP_CUBEJS_API_URL || '',
};
